module.exports = {
  audit_logs: 'Audit logs',
};
